export default __webpack_public_path__ + "static/media/mobile-tour-learn-img.825e81da.svg";